import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex)

var store = new vuex.Store({
  state: {
    count: 0,
    shuomingStatus: false
  },
  mutations: {
    setCartCount (state, count) {
      state.count = count
    },
    changeShuomingStatus (state) {
      state.shuomingStatus = !state.shuomingStatus
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex.js